(function() {
  'use strict';
  angular.module('common')
  .filter('userStatus', [function() {
    return function(val) {
      if (val) {
        return val.charAt(0).toUpperCase() + val.slice(1);
      }
    };
  }]);
})();
